

export const getDownloadUserAcc = async (setDownloadUserAcc) => {
    var endpoint = '/admin//users/download/all.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET'
        });
        res.json().then((res) => {
            setDownloadUserAcc(res.data)
        });
        if(!res.ok){
            throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
    }catch(err) {

    }
}